import { AuthenticationService } from '../../shared/services/authentication.service';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import * as CriptoJS from 'crypto-js';
import { EncriptyUtilService } from '../../shared/services/encripty-util.service';
import { NbDialogService, NbSidebarService } from '@nebular/theme';
import { LayoutService } from '../../@core/utils';
import { environment } from '../../../environments/environment';
import { LoginService } from './login.service';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalFalhaLoginComponent } from './modal-falha-login/modal-falha-login.component';
import { DocumentoHelper } from '../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  forgotPassForm: FormGroup;
  public portalVersion = null;
  public customLogin = null;
  public isProduction = environment.production

  captchaToken = null;


  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private encriptyService: EncriptyUtilService,
    private formBuilder: FormBuilder,
    private notifications: NotificationsService,
    private route: ActivatedRoute,
    private service: LoginService,
    private cd: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService,
    private dialogService: NbDialogService,
  ) {
    this.loginForm = this.formBuilder.group({
      login: ['', Validators.required],
      senha: ['', Validators.required]
    });

    this.forgotPassForm = this.formBuilder.group({
      username: ['', Validators.required]
    });

    this.portalVersion = environment.portalVersion;
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');

    if (resCustom == null) {
      this.customerWL();
    } else {
      let resCustom = localStorage.getItem('bway-customLogin');
      this.customLogin = JSON.parse(resCustom);
      document.title = this.customLogin.title;
    }

    this.addRecaptchaScript();
  }

  customerWL() {
    this.spinnerService.show();

    let urlClient = window.location.href;
    let params = new HttpParams();
    params = params.append('urlClient', urlClient);

    this.service.customerWL(
      params,
      (response) => {
        localStorage.setItem('bway-url', urlClient);
        localStorage.setItem('bway-Session-Time', response.idleSessionTimePortal);
        document.title = response.textNamePortal;
        this.customLogin = {
          logo: response.imageLogin,
          headerMenu: response.iconAreaLoggedPortal,
          primaria: response.colorPrimaryButton,
          secundaria: response.colorSecondaryButton,
          terciario: response.colorTertiaryButton,
          home: response.colorMenuPortal,
          label: response.colorLabel,
          title: response.textNamePortal,
          whatsapp: response.numberWhatsApp,
          cardProduto: response.colorCardProduct,
          alertError: response.colorAlertErrorPortal,
          alertSucesso: response.colorAlertSucessPortal,
          backgroundPortal: response.colorBackgroundPortal,
          iconPage: response.iconPage,
          urlCustomer: response.urlCustomer,
          textWhatsApp: response.textServiceWhatsApp,
          imagemBackgroundLogin: response.imagemBackgroundLogin,
          textoPrincipalLogin: response.textoPrincipalLogin,
          textoSecundarioLogin: response.textoSecundarioLogin,
          corTextoLogin: response.corTextoLogin
        }
        localStorage.setItem('bway-customLogin', JSON.stringify(this.customLogin));

        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.error.message)
      });
  }

  getLoginLogo() {
    return this.customLogin && this.customLogin.logo ? 'url(data:image/png;base64,' + this.customLogin.logo + ') no-repeat left/cover' : './../images/'
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  private normalizarLoginSeDocumento(valor: string | null | undefined): string {
    if (valor == null) return '';
    const str = String(valor).trim();
    if (str === '') return '';
    if (str.indexOf('@') >= 0) {
      return str;
    }

    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    if (tipo === 'CPF' || tipo === 'CNPJ') {
      return DocumentoHelper.normalizarParaEnvio(str, tipo);
    }

    return str;
  }

  login() {
    const usuario = this.normalizarLoginSeDocumento(this.loginForm.controls['login'].value);
    let senha = this.loginForm.controls['senha'].value;

    senha = CriptoJS.SHA256(senha).toString(CriptoJS.enc.Hex);

    this.spinnerService.show();
    // Conforme solicitado e para agilizar os testes, o reCAPTCHA é ignorado nos ambientes DEV e QA.
    // Em produção, a validação do reCAPTCHA continua obrigatória.
    if (!this.isProduction  || this.captchaToken !== null) {
      this.authenticationService.getToken(usuario, senha, this.captchaToken)
        .subscribe(
          re => this.saveLogin(re), error => {
            this.spinnerService.hide();

            let data: any;

            if (error.status == 401 && error.error.titulo != null
              && error.error.subtitulo != null && error.error.mensagem != null) {
              data = {
                titulo: error.error.titulo,
                subtitulo: error.error.subtitulo,
                mensagem: error.error.mensagem,
              };

            } else {
              data = {
                titulo: 'Usuário ou senha inválidos!',
                subtitulo: 'Atenção!',
                mensagem: error.error.message,
              };

            }

            this.dialogService.open(ModalFalhaLoginComponent, {
              context: {
                data: data,
              },
            });

          });
    } else {
      this.notifications.error('reCAPTCHA é obrigatório!');
      this.spinnerService.hide();
    }

  }

  private saveLogin(result) {

    localStorage.setItem('bway-domain', this.encriptyService.encriptyBySecretKey(this.getDominio(result)));
    localStorage.setItem('bway-user', this.encriptyService.encriptyBySecretKey(result.usuario));
    localStorage.setItem('bway-product-id', null);
    localStorage.setItem('bway-token', result.token);
    localStorage.setItem('bway-logged-date', new Date().toString());
    localStorage.setItem('bway-enterprise-name', this.encriptyService.encriptyBySecretKey(result.empresaRazaoSocial));
    localStorage.setItem('bway-product-description', this.encriptyService.encriptyBySecretKey(result.produtoDescricao));
    localStorage.setItem('bway-enterprise-federal-id', this.encriptyService.encriptyBySecretKey(result.cpfCnpj));
    this.spinnerService.hide();
    this.router.navigate(['/iot-dashboard']);

  }

  private getDominio(result) {
    if (result.empresaId != null) {
      return 'EMPRESA';
    }
    return 'BACKOFFICE';
  }

  reset_senha(data) {

    const loginNorm = this.normalizarLoginSeDocumento(data.login);
    let login = this.encriptyService.encriptyBySecretKey('' + loginNorm).toString()
    let dominio = this.encriptyService.encriptyBySecretKey('PORTAL').toString()
    let params = { login: login, dominio: dominio }
    this.router.navigate(['../reset-senha'], { relativeTo: this.route, queryParams: params });

  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      
      this.renderReCaptcha();
    };

    (function (d, s, id, obj) {
      let js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        obj.renderReCaptcha();
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': environment.recaptcha.siteKey,
      'callback': (response) => {
        //this.captchaToken = response;
        this.startExpirationTimer(response);
      },
    });
  }

  startExpirationTimer(res) {
    this.captchaToken = res;
    this.cd.detectChanges();
    setTimeout(() => {
      this.captchaToken = null;
      this.cd.detectChanges();
    }, 60000);
  }

}

